import { render, staticRenderFns } from "./BaseConfirmWithAvatar.vue?vue&type=template&id=22b417bf&scoped=true&"
import script from "./BaseConfirmWithAvatar.vue?vue&type=script&lang=ts&"
export * from "./BaseConfirmWithAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseConfirmWithAvatar.vue?vue&type=style&index=0&id=22b417bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b417bf",
  null
  
)

export default component.exports